export enum EPlatform {
	IOS = 'ios',
	ANDROID = 'android',
	UNKNOWN = 'unknown',
}